<template>
<a-col :span="24" class="setting-content">
    <a-row style="margin-bottom: 10px; text-align: left;">
        <a-button type="primary" @click="showAdd">新建长尾主题</a-button>
    </a-row>
    <a-modal 
        v-model="addPanel" 
        title="新建长尾主题" 
        :footer="null" 
        width="800px" 
        :bodyStyle="autoHeight">
        <edit-long-tail @additem="addItem"/>
    </a-modal>
    <a-row v-if="longTailData.length >=0" class="setting-list">
        <a-row class="title-style">
            <a-col :span="24">
                <a-col 
                    :xs="6" :sm="6" :md="4" :lg="4" :xl="4" :xxl="4" 
                    style="text-align: left;">
                    <span>主题</span>
                </a-col>
                <a-col 
                    :xs="10" :sm="10" :md="16" :lg="16" :xl="16" :xxl="16" 
                    style="text-align: left;">
                    <span>种子词</span>
                </a-col>
                <a-col 
                    :xs="{span: 6}" 
                    :sm="{span: 6}" 
                    :md="{span: 3}" 
                    :lg="{span: 2}" 
                    :xl="{span: 2}" 
                    :xxl="{span: 2}" 
                    style="text-align: center;"> 
                    <span>创建时间</span> 
                </a-col>
                <a-col 
                    :xs="2" :sm="2" :md="1" :lg="1" :xl="1" 
                    style="text-align: center;">
                    <span>操作</span>
                </a-col>
            </a-col>
        </a-row>

        <a-row :key="refresh">
            <a-row v-for="(longTailItem, index) in longTailData" :key="index" class="item-style">
                <a-col :span="24">
                    <a-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4" :xxl="4" class="line-style"> 
                        <span> {{longTailItem.task_name}} </span> 
                    </a-col>
                    <a-col :xs="10" :sm="10" :md="16" :lg="16" :xl="16" :xxl="16"> 
                        <a-col :xs="21" :sm="21" :md="23" :lg="23" :xl="23" :xxl="23"  class="line-style"> 
                            <span v-if="editTag== false || taskId!= longTailItem.task_id ">             
                                {{longTailItem.seedwords}}
                            </span>
                            <a-select 
                                v-if="editTag == true && taskId== longTailItem.task_id"
                                v-model="seedWords"  
                                mode="tags" 
                                :defaultValue="seedWords" 
                                @change="handleTag"
                                :key="refresh" 
                                placeholder="Tags Mode"  
                                style="width: 100%">
                            </a-select>
                        </a-col>
                        <a-col :xs="3" :sm="3" :md="1" :lg="1" :xl="1" :xxl="1"> 
                            <a-col> 
                                <a-icon 
                                    type="save" 
                                    v-if="editTag == true && taskId== longTailItem.task_id"
                                    @click="updateItem(longTailItem)"  
                                    style="text-align: right; margin-top: 8px"
                                />
                            </a-col>
                            <a-col> 
                                <a-icon 
                                    type="edit" 
                                    v-if="editTag == false || taskId!= longTailItem.task_id" 
                                    @click="tagPopover(longTailItem)"
                                    style="text-align: right; margin-top: 8px"
                                />
                            </a-col>
                        </a-col>
                    </a-col>
                    <a-col  
                        :xs="{span: 6}" 
                        :sm="{span: 6}" 
                        :md="{span: 3}" 
                        :lg="{span: 2}" 
                        :xl="{span: 2}"  
                        :xxl="{span: 2}"  
                        class="line-style"
                        style="text-align: center;">
                        {{longTailItem.create_time|timeChange}}
                    </a-col>
                    <a-col 
                        :xs="2" :sm="2" :md="1" :lg="1" :xl="1" :xxl="1" 
                        class="line-style" 
                        style="text-align: center;"> 
                        <a-icon  
                            type="delete" 
                            @click="deleteItem"
                            style="font-size: 16px; margin-top: 6px;"
                        />
                    </a-col>
                </a-col>
            </a-row>
        </a-row>
    </a-row>   
</a-col>
</template>

<script>

import EditLongTail from './EditLongTail.vue'

export default 
{
    name: 'longtaillist',

    data() 
    {
      return {
          tab: "uc,ltls",
          editPanel: false,
          addPanel: false,
          editTag: false,
          longTailData: [],
          seedWords: [],
          taskId: "123",
          refresh: 1,
          autoHeight: {
              height: '170px'
          }
      }
    },

    components: 
    {
        EditLongTail
    },

    filters: 
    {
        splitString(value) 
        {
            let origString= value;
            let wordList = origString.split(" ");
            return wordList;
        },
        timeChange(value) 
        {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        }
    },

    methods: 
    {
        handleTag: function(value) 
        {
            this.seedWords = value;
        },

        tagPopover:  function(longTailItem) 
        {
            let swString= longTailItem.seedwords;
            let swArray= swString.split(" "); 
            if (this.editTag == false)
            { 
                this.taskId= longTailItem.task_id,    
                this.seedWords= swArray,  
                this.editTag = true     
            }
            else
            {
                this.editTag = false
            }      
        },

        updateItem: function(longTailItem)  
        {
            this.editTag= false      
            let currentId= longTailItem.task_id;
            let swArray= this.seedWords;
            let swString=swArray.join(" ");
            let postdata = {
                task: "LONGTAIL_TASK_UPDATE",
                task_id: currentId,
                seedwords: swString,
                task_name:  longTailItem.task_name,
            };
            let that = this;
            let updateList= [];
            that.post("longtail", postdata)
                .then(function(data) 
                {
                    if (data.ret == 200) 
                    {
                        that.$message.success("成功保存种子词！");
                        that.refresh += 1;
                        for (let i = 0; i < that.longTailData.length; i++)
                        {
                            if(that.longTailData[i].task_id==currentId)
                            {
                                that.longTailData[i].seedwords=swString;
                                updateList.push(that.longTailData[i]);
                            }
                            else
                            {
                                updateList.push(that.longTailData[i]);
                            }
                        }
                        that.longTailData=updateList;            
                    }
                    else
                    {
                        that.$message.info("保存失败！");
                    }
                })
                .catch(function (e) 
                {
                    console.log(e);
                    that.$message.error("failed");
                })   
        },

        addItem: function(content, item) 
        {      
            let postdata = {
                task: "LONGTAIL_TASK_CREATE",
                task_name: content.taskName,
                seedwords: content.seedWords,
            };
            let that = this;
            let updateList= that.longTailData;
            that.post("longtail", postdata)
                .then(function(data) 
                {
                    if (data.ret == 200) 
                    {
                        that.$message.success("保存成功！");
                        that.addPanel = false
                        updateList.unshift({"task_name": content.taskName,"seedwords": content.seedWords,"create_time":(new Date()).valueOf()});
                        that.longTailData=updateList;
                        that.refresh += 1;
                    }
                    else
                    {
                        that.$message.info("保存失败！");
                    }
                })
                .catch(function (e) 
                {
                    console.log(e);
                    that.$message.error("failed");
                })   
        },

        deleteItem: function(order) 
        {
            let postdata = {
              task: "DELETE_LONGTAIL_TASK",
              order: order
            };
            let that = this;
            that.post("longtail", postdata)
            that.$message.info("This action is not functional");
        },

        showAdd: function() 
        {
            this.addPanel = true
        },
    },

    created() 
    {
        this.$store.commit('changetab', this.tab)
        let postdata = {
            task: "LONGTAIL_SEEDWORD_LIST",
            "api-path": "longtail",
            "from": 0,
            "to": 100
        }
        let that = this;
        that.post(postdata["api-path"], postdata)
            .then(function(data) 
            {
              if (data.ret == 200) 
              {
                  that.longTailData = data.data;
              }
            })
            .catch(function (e) 
            {
            });
    }
}
</script>

<style scoped>

    .setting-content 
    {
        margin: 0px 0px;
        border: 0px solid #d1d5da;
    }
    
    .setting-list 
    {
        margin: 0px 0px;
    }

    .title-style
    {
        font-size: 13px;
        font-weight: 600;
        padding: 4px;
        border-bottom: 1px solid #d1d5da;
    }

    .item-style 
    {
        padding: 4px;
        border-left: 1px solid #d1d5da;
        border-right: 1px solid #d1d5da;
        border-bottom: 1px solid #d1d5da;
    }

    .line-style 
    {
        line-height: 32px;
        overflow: hidden;
        text-align: left;
    }

    .max1200 
    {
        max-width: 1200px;
        margin: auto;
        height: 100%;
        padding: 0px 0px;
    }

</style>
